import {ProtocolCommand} from '../../../service-model/protocol-command.interface';
import {SHELL_PROTOCOL_OPERATIONS_NS} from '../shell-protocol-namespace.const';

export class ForceDisconnectGateway implements ProtocolCommand {
  constructor(public gatewayId: string) { }

  getOperationName(): string {
    return `${SHELL_PROTOCOL_OPERATIONS_NS}.ForceDisconnectGateway`;
  }
}
